import { configureStore } from "@reduxjs/toolkit";
import displayReducer from './features/displaySlice';
import authReducer from './features/authSlice';
import notificationsReducer from './features/notificationsSlice';
import searchReducer from "./features/searchSlice";
import inboxNotificationReducer from './features/inboxSlice';

export const store = configureStore({
    reducer: {
        display: displayReducer,
        auth: authReducer,
        notifications: notificationsReducer,
        search: searchReducer, // For product string search queries etc,
        inbox: inboxNotificationReducer
    }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch